import * as React from 'react';
import * as ValidateConstant from '../../wizard/constants/ValidateConstant';
import AssetsManager from '../utils/AssetsManager';
import {OptionsMonthlyProps} from '../types/components';

class OptionsMonthly extends React.Component<OptionsMonthlyProps, {}> {
    constructor(props) {
        super(props);
    }

    static defaultProps = {
        customClassLabel: ''
    };

    onChange = (event, item, id) => {
        const error = this.validateEmpty(item);
        this.props.onChange(item, error, id);
    }

    validateEmpty = value => this.props.required && !value ? ValidateConstant.ERROR_REQUIRED : null;

    renderLabel = (value, id, defaultValue, isSmall) => {
        const {customClassLabel} = this.props;
        return <label className={customClassLabel} htmlFor={id}>
            <div className={`monthly ${value === defaultValue ? 'checked' : ''} ${isSmall ? 'small' : ''}`}>
                <div>{value}</div>
            </div>
            <div className="label text-center">Meses</div>
        </label>;
    }

    render() {
        const {
            id, name, label, options, required, labelError, hasError, defaultValue
        } = this.props;
        const invalidClass = hasError && labelError && 'is-invalid';
        return (
            <div className="options-monthly">
                {label ? <label>{label}{required && <span className="asterisk">*</span>}
                    {hasError && labelError && <img className="ic" alt=""
                                                    src={AssetsManager('/assets/images/common/warning-icon.svg')}/>}
                </label> : ''
                }
                {options && options.map((item, index) => {
                    const inputId = `${id}-${index}`;
                    return (
                        <React.Fragment key={index}>
                            <input type="radio"
                                   className="d-none"
                                   id={inputId}
                                   required={required}
                                   name={name}
                                   value={item.value}
                                   onChange={e => this.onChange(e, item, id)}
                            />
                            {this.renderLabel(item.value, inputId, defaultValue, options.length > 5)}
                        </React.Fragment>
                    );
                })}
                {hasError && labelError &&
                <strong id={`${name}Help`}
                        className={`form-text ${invalidClass}`}>
                    {labelError}
                </strong>}
            </div>
        );
    }
}

export default OptionsMonthly;
